import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const NotFound = () => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light">
            <div className="text-center p-5 bg-white rounded-4 shadow-lg border border-light" style={{ maxWidth: "600px" }}>
                <h1 className="display-3 fw-bold" style={{ color: "#6d2041" }}>
                    404
                </h1>
                <h3 className="fw-semibold mb-3" style={{ color: "#343a40" }}>
                    Page Not Found
                </h3>
                <p className="text-muted mb-4">
                    Oops! The page you’re looking for doesn’t exist or may have been moved.
                </p>
                <div className="d-flex justify-content-center gap-3">
                    <Link to="/" className="btn text-white px-4" style={{ backgroundColor: "#6d2041" }}>
                        Go Back Home
                    </Link>
                    <Link to="/contact" className="btn btn-outline-dark px-4">
                        Contact Us
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
